export const ExportJobLOADING = "exportJob/Loading";
export const ExportJobERROR = "exportJob/Error";
export const ExportJobListSUCCESS = "exportJob/ListSuccess";
export const ExportJobCreateSUCCESS = "exportJob/CreateSuccess";
export const ExportJobUpdateSUCCESS = "exportJob/UpdateSuccess";
export const ExportJobDeleteSUCCESS = "exportJob/DeleteSuccess";
